import { type Form } from '@wix/ambassador-forms-v4-form/types';
import { deepEqual } from 'fast-equals';
import { useEffect, useMemo, useRef } from 'react';

import { autofillValues } from '../../components/form/autofill';
import { type FormConfig, type FormValues, type OnChange } from '../../types';
import { fillEmptyValues } from '../form-values';

import { normalizeValues } from './normalize-values';

export const useFormValues = (
  form?: Form,
  values?: FormValues,
  onChange?: OnChange,
  config?: FormConfig | null,
  enableAutofill?: boolean,
): FormValues => {
  const hasAutofilled = useRef(false);

  const normalizedValues = useMemo(() => {
    let filled = fillEmptyValues(form, values);
    if (enableAutofill && !hasAutofilled.current && config?.userData) {
      hasAutofilled.current = true;
      filled = autofillValues(form, filled, config);
    }
    return normalizeValues(form, filled, true, config);
  }, [form, values, config, enableAutofill]);

  useEffect(() => {
    const hasAnyValueChanged = !deepEqual(normalizedValues, values);
    if (hasAnyValueChanged) {
      onChange?.(normalizedValues);
    }
  }, [values, normalizedValues, onChange]);

  return normalizedValues;
};
